import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ValidTokenGuard } from '../dave-data-module/guards/valid-token.guard';
import { TaskPageMeta } from '../helper/page-metadata';
import { TaskPageComponent } from './components/task-page/task-page.component';

const routes: Routes = [
    {
        path: '',
        canActivate: [ValidTokenGuard],
        canActivateChild: [ValidTokenGuard],
        data: {
            breadcrumb: TaskPageMeta.Breadcrumb,
            breadcrumbIcon: TaskPageMeta.Icon,
        },
        resolve: {
            ...TaskPageComponent.RequiredResolvers,
        },
        children: [
            {
                path: ':taskId',
                data: { breadcrumb: 'none' },
                component: TaskPageComponent,
            },
            {
                path: '',
                data: { breadcrumb: 'none' },
                component: TaskPageComponent,
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
})
export class DaveTasksRoutingModule {}
